export default __webpack_public_path__ + "static/emilytesting-1c57e79aa6390c51ff153c5ab925e3ec.png";